import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { endAuthSession } from "../../services/authSession";

const API_URL = import.meta.env.VITE_API_URL || "https://api.lastiqo.com/api";

const ZorunluSifreDegistir = ({ onTamamlandi }) => {
  const navigate = useNavigate();
  const [yeniSifre, setYeniSifre] = useState("");
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState("");
  const [hata, setHata] = useState("");
  const [bilgi, setBilgi] = useState("");
  const [yukleniyor, setYukleniyor] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata("");
    setBilgi("");

    if (!yeniSifre || !yeniSifreTekrar) {
      setHata("Yeni şifre ve tekrar alanları zorunludur.");
      return;
    }

    if (yeniSifre.length < 6) {
      setHata("Şifre en az 6 karakter olmalıdır.");
      return;
    }

    if (yeniSifre !== yeniSifreTekrar) {
      setHata("Şifreler eşleşmiyor.");
      return;
    }

    setYukleniyor(true);
    try {
      const token = localStorage.getItem("pl_token");
      const res = await fetch(`${API_URL}/auth/zorunlu-sifre-degistir`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ yeniSifre }),
      });

      if (res.status === 401) {
        endAuthSession("expired");
        return;
      }

      const data = await res.json();

      if (!res.ok) {
        setHata(data?.mesaj || "Şifre güncellenemedi.");
        return;
      }

      const mevcut = JSON.parse(localStorage.getItem("pl_kullanici") || "{}");
      const guncel = data?.kullanici || { ...mevcut, sifreDegistirmeZorunlu: false };
      localStorage.setItem("pl_kullanici", JSON.stringify(guncel));

      setBilgi("Şifreniz güncellendi. Yönlendiriliyorsunuz...");
      if (onTamamlandi) onTamamlandi();
      setTimeout(() => navigate("/", { replace: true }), 800);
    } catch {
      setHata("Sunucuya bağlanılamadı.");
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f6f7fb", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 460, background: "#fff", borderRadius: 14, padding: 26, boxShadow: "0 10px 30px rgba(0,0,0,0.08)" }}>
        <h2 style={{ marginTop: 0, marginBottom: 8, color: "#1a1a2e" }}>Yeni Şifre Oluştur</h2>
        <p style={{ marginTop: 0, color: "#666", fontSize: 14 }}>
          Güvenlik nedeniyle ilk girişte varsayılan şifrenizi değiştirmeniz gerekiyor.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, marginBottom: 6 }}>YENİ ŞİFRE</label>
          <input
            type="password"
            value={yeniSifre}
            onChange={(e) => setYeniSifre(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: 11, borderRadius: 8, border: "1px solid #d8dbe2", marginBottom: 14 }}
          />

          <label style={{ display: "block", fontSize: 12, fontWeight: 600, marginBottom: 6 }}>YENİ ŞİFRE (TEKRAR)</label>
          <input
            type="password"
            value={yeniSifreTekrar}
            onChange={(e) => setYeniSifreTekrar(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: 11, borderRadius: 8, border: "1px solid #d8dbe2", marginBottom: 14 }}
          />

          {hata && <div style={{ color: "#b3261e", marginBottom: 10, fontSize: 13 }}>{hata}</div>}
          {bilgi && <div style={{ color: "#166534", marginBottom: 10, fontSize: 13 }}>{bilgi}</div>}

          <button
            type="submit"
            disabled={yukleniyor}
            style={{ width: "100%", border: 0, borderRadius: 8, padding: 12, background: "#e63946", color: "#fff", fontWeight: 700, cursor: yukleniyor ? "not-allowed" : "pointer" }}
          >
            {yukleniyor ? "Kaydediliyor..." : "Şifreyi Güncelle"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ZorunluSifreDegistir;
